module.exports = __webpack_public_path__ + "static/sign-up2-f8d96736d57a9cf4184d0e2de2aeef18.png";